module.exports = __webpack_public_path__ + "static/media/connection_service_business_unit_3.d84535f0.png";